import { LitElement, html, css } from 'lit';
import { accessibility } from '../../utilities/styles';
import { EventManager } from '../../utilities/events';
export class AllInPagination extends LitElement {
    static properties = {
        total: { type: Number },
        pageSize: { type: Number },
        name: { type: String },
        currentPage: { type: Number },
    };
    constructor() {
        super();
        this.eventManager = new EventManager(this);
    }
    render() {
        if (this.total && this.pageSize && this.total > this.pageSize) {
            let totalPages = Math.ceil(this.total / this.pageSize);
            let pages = [];
            for (let i = 1; i <= totalPages; i++) {
                if (i === this.currentPage) {
                    pages.push(html `<li aria-current="page"><span class="current">${i}</span></li>`);
                }
                else {
                    pages.push(html `<li><a href="#" @click="${(e) => { e.preventDefault(); this._goToPage(i); }}">${i}</a></li>`);
                }
            }
            if (this.currentPage > 1) {
                pages.unshift(html `<li><a href="#" @click="${(e) => { e.preventDefault(); this._goToPage(this.currentPage - 1); }}">&#8249; Previous</a></li>`);
                pages.unshift(html `<li><a href="#" @click="${(e) => { e.preventDefault(); this._goToPage(1); }}">&laquo; First</a></li>`);
            }
            if (this.currentPage < totalPages) {
                pages.push(html `<li><a href="#" @click="${(e) => { e.preventDefault(); this._goToPage(this.currentPage + 1); }}">Next &#8250;</a></li>`);
                pages.push(html `<li><a href="#" @click="${(e) => { e.preventDefault(); this._goToPage(totalPages); }}">Last &raquo;</a></li>`);
            }
            return html `\n                <nav class="pagination" role="navigation" aria-label="Select page of results">\n                    <ol>\n                        ${pages}\n                    </ol>\n                </nav>`;
        }
    }
    _goToPage(page) {
        this.currentPage = page;
        this.eventManager.emit(`allin-change-page-${this.name}`, { page: page });
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    static styles = [
        accessibility,
        css `

            .pagination ol {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                width: 100%;
                gap:2px;
                align-items: center;
            
                list-style: none;
                margin:0;
                padding:0;
                display: flex;
                margin-top:2rem;
            }
            .pagination li a,
            .pagination li .current {
                display:block;
                margin:0;
                padding:0.5rem 1rem;
                background-color:var(--color-primary);
                transition:background-color var(--transition) ease;
            }
            .pagination li a{
                color:var(--color-black-to-white);
                text-decoration:none;
            }
            .pagination li a:hover,
            .pagination li a:focus {
                background-color:var(--color-secondary);
                color:var(--color-white-to-black);
            }
            .pagination li .current{
                background-color:var(--color-secondary);
                color:var(--color-white-to-black);
            }

            
        `
    ];
}
